import CityPageTemplate from "../city-template/CityPageTemplate";
import { elCajonConfig } from "./data";

export default function ElCajonPage() {
  return <CityPageTemplate config={elCajonConfig} />;
}